<template>
  <div class="animated fadeIn list-of-coa">
    <b-card>
      <div slot="header">Dimension Account
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="refresh()"><i class="fa fa-refresh"></i> Refresh</button>
          <b-button variant="btn btn-primary" @click="close">Close</b-button>
        </div>
      </div>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        striped hover
        :items="data"
        :fields="tblData.fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
      >
        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="6">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="6">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    <b-modal v-model="showForm" header-bg-variant="primary"  :title="formTitle" :centered="true" @ok="handleOk">
      <b-form @submit.stop.prevent="save">
          <b-form-group label-cols=3 label="Is Used" >
             <b-form-select v-model="model.isUsed" :plain="true" :options="YesNo"></b-form-select>
          </b-form-group>
          <b-form-group label-cols=3 label="Account Code" >
            <b-form-input v-model="model.DimColName" readonly></b-form-input>
          </b-form-group>
          <div class="error" v-if="!$v.model.DimColName.required">Field is required</div>          
          <b-form-group label-cols=3 label="Account Name">
            <b-form-input v-model="model.DimColDesc"></b-form-input>
          </b-form-group>
          <b-form-group label-cols=3 label="Entry Caption">
            <b-form-input v-model="model.Caption"></b-form-input>
          </b-form-group>
          <b-form-group label-cols=3 label=" Filter Cap">
                <b-form-input v-model="model.FilterCap"></b-form-input>
          </b-form-group>
          <b-form-group label-cols=3 label="Sequence">
                <b-form-input v-model="model.DimSequence" type="number" ></b-form-input>
          </b-form-group>
      </b-form>
    </b-modal>

    </b-card>
  </div>
</template>

<style lang="scss">
.list-of-coa {
iframe {
  border: 1px solid #ccc;
  width: 100%;
  height: 11in;
}

}
</style>


<script>
import toastr from "mini-toastr";
import dimension from "../../apis/dimension";
import vNumber from "vue-numeric";
import { validationMixin } from "vuelidate";
import { required, maxLength,numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
      DimColName: {
        required,
         maxLength: maxLength(50)
      },
      DimColDesc: {
        required,
         maxLength: maxLength(100)
      },
      Caption: { required },
      FilterCap: { required },
      DimSequence: { required },
      isUsed: { required },
    }
  },  components: { vNumber },
  data() {
    return {
      YesNo : [{ value: 1, text: 'Yes' }, { value: 0, text: 'No' }],
      formTitle: 'Add - Dimension Account',
      showForm:false,
      showDelConfirm: false,
      horizontal: true,
      model:{      
        DimColName: '',
        DimColDesc: '',
        Caption: '',
        FilterCap: '',
        DimSequence: '',
        isUsed: 0,
      },
      striped: false,
      tblData: {
        items: [],
        fields: [
          {
            key: "DimColName",
            thStyle: "width:100px",
            label: "Account #"
          },
          {
            key: "DimColDesc",
            label: "Account Name",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "Caption",
            label: "Entry Caption",
          },
          {
            key: "FilterCap",
            label: "Filter Caption"
          },
          {
            key: "DimSequence",
            label: "Sequence",
            thStyle: "width:100px",
            tdClass: "text-center"
          },
          {
            key: "isUsed",
            label: "Used ?",
            thStyle: "width:100px",
            tdClass: "text-center"
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:100px",
            thClass: "text-center",
          },

        ],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: null,
        sortDesc: false,
      },
    };
  },
//   created: async function() {
//       this.tahunBuku = await dimension.tahunbuku();
//   },
  computed: {
    isValid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
    //   this.tblData.DimColDesc = this.tblData.filter;

      const list = await dimension.list(this.tblData);      
      return list;
    },
    edit: function(data) {
      if (data.DimColName=='Dim1') {
            toastr.error('Dim1 is mandatory for Department, not alterable');
      } else if (data.DimColName=='Dim2') {
            toastr.error('Dim2 is mandatory for Program/Project, not alterable');      
      } else {
          const item={};
          for (var key in data) {
              if (data[key])
              item[key] = data[key];
          }      
          this.model = item;
          this.model.kodelama=item.DimColName;
          this.formTitle='Edit - Dimension Account';
          this.showForm = true;
      }
    },
    handleOk: function(evt) {
      const { model, isValid } = this;
      evt.preventDefault()
      if (!isValid) {
        alert('Please fill the form correctly.')
      } else {
        this.save()
      }
    },
    save: async function() {
      const { model, isValid } = this;
      if (isValid==true) {
        try {
            await dimension.update(model);
          this.showForm = false;
          this.refresh();
        } catch (error) {
            console.log('save : ', error)
          toastr.error(JSON.stringify(error), "ERROR MESSAGE");
        }
      }
    },
    exportXls: function() {
      dimension.exportXls();
    },
    refresh() {
      this.$refs.table.refresh();
    },
    close(){
      router.push("home");
    }    
  }
};
</script>
